<div class="layout-wrapper" [class.hidden-layout]="isLayoutHidden">
  <div class="sidebar" [class.collapsed]="isSidebarCollapsed">
    <div class="sidebar-toggle" (click)="toggleSidebar()">
      <span class="toggle-icon" *ngIf="!isSidebarCollapsed">
        <i class="fa-sharp-duotone fa-solid fa-arrow-left-from-line"></i> <!-- Arrow left for expanded -->
      </span>
      <span class="toggle-icon" *ngIf="isSidebarCollapsed">
        <i class="fa-sharp-duotone fa-solid fa-arrow-right-from-line"></i> <!-- Arrow right for collapsed -->
      </span>
    </div>
    <nav>
      <ul>
        <li *ngFor="let link of navLinks">
          <a [routerLink]="link.route"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: true }">
            <span class="icon" [innerHTML]="link.icon"></span>
            <span *ngIf="!isSidebarCollapsed">{{ link.text }}</span>
          </a>
        </li>
        <hr *ngIf="adminNavLinks.length > 0"/>
        <li *ngFor="let link of adminNavLinks">
          <a [routerLink]="link.route"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: true }">
            <span class="icon" [innerHTML]="link.icon"></span>
            <span *ngIf="!isSidebarCollapsed">{{ link.text }}</span>
          </a>
        </li>
        <hr />
        <li class="logout-button">
          <a (click)="logout()">
            <span class="icon">
              <i class="fa-sharp-duotone fa-solid fa-right-from-bracket"></i>
            </span>
            <span *ngIf="!isSidebarCollapsed">Log Out</span>
          </a>
        </li>
      </ul>
    </nav>

  </div>

  <div class="content">
    <div class="top-bar">
      <div class="logoContainer">
        <img src="../../assets/new-co-logo-lg.png" alt="CareOregon Logo" class="logo" />
      </div>
      
      <span>Dental Bidirectional <span *ngIf="displayName"> - {{displayName}}</span></span>
    </div>

    <div class="router-outlet-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
